import actionTypes from './formEditor.actionTypes';
import { addErrorMessage, addSuccessMessage } from '../Common/Components/flashMessage/flashMessage.actions';
import * as FormsApiService from '../Common/Services/FormsApiService';
import { isNullOrEmptyString, truncateTextIfMaxEscapedLengthExceeded } from '../Common/Services/utilities';
import uuidv4 from 'uuid/v4';


export const createFormTemplate = (companyId, employeeId, formTypeId, createdByName, wizardFormName, wizardFormCategoryType) =>
    ({ type: actionTypes.CREATE_FORM_TEMPLATE, payload: { companyId, employeeId, formTypeId, createdByName, wizardFormName, wizardFormCategoryType } });

export const formEditorConfigurationChanged = (configuration) => ({ type: actionTypes.FORM_EDITOR_CONFIGURATION_CHANGED, payload: {configuration} });

export const formEditorQuestionsValidChanged = (valid) => ({ type: actionTypes.FORM_EDITOR_QUESTIONS_VALID_CHANGED, payload: {valid} });

export const formEditorFieldChanged = (field, value) => ({
  type: actionTypes.FORM_EDITOR_FIELD_CHANGED,
  payload: { field, value }
});


const resetCopyFields = (form, viewedCompanyId) => {
  form.sourceFormTemplateId = form.id;
  form.companyId = viewedCompanyId;
  form.id = undefined;
  form.templateName = "Copy of " + form.templateName;
  form.ownerEmployeeId = undefined;
  form.isTemplateOwner = true;
  form.isDefaultTemplate = false;
  form.isArchived = false;
  form.launchCount = 0;
  return form;
};

export const loadFormTemplate = (companyId, employeeId, formId, copy, share, view, createdByName, wizardFormName, wizardFormCategoryType) => {
  return async dispatch => {
    dispatch({ type: actionTypes.RESET_FORM_EDITOR_STATE });
    dispatch({ type: actionTypes.LOAD_FORM_TEMPLATE_BEGIN, payload: { companyId, employeeId, createdByName } });

    const response = await FormsApiService.getFormTemplate(companyId, employeeId, formId);
    if (response) {
      let form = response;
      if (copy) {
        let sourceFormTemplateId = form.id;
        form = resetCopyFields(form, companyId);
        form.sourceFormTemplateId = sourceFormTemplateId;
        form.templateName = wizardFormName ? wizardFormName : form.templateName;
        form.formCategoryTypeId = wizardFormCategoryType && !isNullOrEmptyString(wizardFormCategoryType.value) ? wizardFormCategoryType.value : form.formCategoryTypeId;
      }
      dispatch({ type: actionTypes.LOAD_FORM_TEMPLATE_SUCCESS, data: { form, copy, share, view } });
    }
    else {
      dispatch({ type: actionTypes.LOAD_FORM_TEMPLATE_FAILURE });
      dispatch(addErrorMessage('Retrieving template failed.', 'Error'));
    }
  };
};

export const saveFormTemplate = (form, saveAsDraft) => {
  return async (dispatch, getState) => {
    let formEditor = getState().formEditor;
    let companyId = formEditor.companyId;
    let employeeId = formEditor.employeeId;
    let formTypeId = formEditor.formTypeId;
    let createdByName = formEditor.createdByName;

    form.templateName = truncateTextIfMaxEscapedLengthExceeded(form.templateName, 100);

    if (!form.id) {
      form.id = 0;
      form.formTemplateGuid = uuidv4();
      form.companyId = companyId;
      form.ownerEmployeeId = employeeId;
      form.formTypeId = formTypeId;
      form.createdByName = createdByName;
      form.isActive = true;
    }

    if(form.isDefaultTemplate){
      // we still need to raise the PctyTalentFormEditorSaved event so that the application using talent forms (e.g. Surveys)
      // can display the appropriate error message and route accordingly
      var evt = new CustomEvent('PctyTalentFormEditorSaved', { detail: form });
      window.dispatchEvent(evt);
      return;
    }

    dispatch({ type: actionTypes.SAVE_FORM_TEMPLATE_BEGIN });

    const response = await FormsApiService.saveFormTemplate(companyId, employeeId, form);
    if (response) {
      form.id = response;
      dispatch({ type: actionTypes.SAVE_FORM_TEMPLATE_SUCCESS, data: form });
      if (!saveAsDraft) {
        dispatch(addSuccessMessage("Template saved.", "Success"));

        var evt = new CustomEvent('PctyTalentFormEditorSaved', { detail: form });
        window.dispatchEvent(evt);
      }
      else {
        var evt = new CustomEvent('PctyTalentFormEditorSavedAsDraft', { detail: form });
        window.dispatchEvent(evt);
      }
    }
    else {
      dispatch({ type: actionTypes.SAVE_FORM_TEMPLATE_FAILURE });
      dispatch(addErrorMessage('Saving template failed.', 'Error'));
    }
  };
};

export const loadQuestionBank = (formTypeId) => {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_QUESTION_BANK_BEGIN });

    const response = await FormsApiService.getQuestionBank(formTypeId);
    const questions = response.data;
    if (questions) {
      dispatch({ type: actionTypes.LOAD_QUESTION_BANK_SUCCESS, data: { questions } });
    }
    else {
      dispatch({ type: actionTypes.LOAD_QUESTION_BANK_FAILURE });
      dispatch(addErrorMessage('Loading question bank failed.', 'Error'));
    }
  };
};